export interface IDialog {
  title: string
  body: string
  type: DialogTypes
  textConfirm?: string
  textDecline?: string
  textCancel?: string
  textCustom?: string
  classConfirm?: string
  classDecline?: string
  onConfirm?: any
  onDecline?: any
  onCancel?: any
  onCustom?: any
  /** Lock the dialog so the user cannot close it by clicking outside of it. */
  lock?: boolean
  mandatedWaitTimeSec?: number
  restoreOriginalFocus?: boolean
  template?: any
  templateProps?: any
}

export enum DialogTypes {
  OK = 1,
  CONFIRM = 2,
  CONFIRM_DECLINE = 3,
  NO_BUTTON = 4,
  CUSTOM = 5
}
